import { TypographyH2, TypographySmall, TypographyXS } from "@/components/ui/typography" 
import { MarketResearch } from "@/types/MarketResearch"
import { formatDateToString } from "@/utils/date"
import { CalendarDays, Camera, CameraOff, Store } from "lucide-react"
import { useNavigate } from "react-router-dom"
import { useBaseStore } from '@/store'
import { Store as StoreZ } from '@/store/type'

interface propsCards {
    data: MarketResearch
}
 
const statusCard = (status: string) => {
    switch (status) {
        case 'Rascunho':
            return 'status-sketch' 
        case 'Publicado': 
            return 'status-published' ; 
        case 'Encerrado': 
            return 'status-closed' ; 
        default:
            return ''
    }
}
 
const stateSelector = (state: StoreZ) => ({ 
    profile: state.authSlice.state.profile
})

 
const CardsResearch = ({data}: propsCards ) => {
    const { profile } = useBaseStore(stateSelector)
    const navigate = useNavigate()

    return (
        <div className='bg-white rounded-2xl p-5 shadow-sm border border-gray-200 card-hover'>
            <div className="flex items-start justify-between mb-3">
                <div className="flex-1">
                    <TypographyH2 className=" font-bold text-gray-900 mb-2">{data.NM_PESQUISA}</TypographyH2>
                    <div className="flex justify-between items-center">
                        <span className={`status-badge status ${statusCard(data.DD_STATUS)}`}> 
                            {data.DD_STATUS}
                        </span>
                        <div className="flex gap-2 items-center">
                            <TypographySmall className="status-badge status status-sketch text-xs text-gray-900">{data.DD_TIPO_CICLO}</TypographySmall> 
                            {data.DD_COLETA_IMAGEM 
                                ? (<Camera size={18}/>)
                                : (<CameraOff size={18}/>)
                            }
                        </div>
                    </div>
                </div>
                </div>

            <div className="space-y-4 my-5">
                <div className="flex gap-4">
                    <div className="info-item flex-1">
                        <Store size={14} />
                        <div className="grid">
                            <TypographySmall className="text-xs text-gray-600">Revenda</TypographySmall>
                            <TypographyXS className="text-sm font-medium text-gray-900">{data.DS_REVENDA}</TypographyXS>
                        </div>
                    </div>
                    <div className="info-item flex-1"> 
                        <CalendarDays size={14}/>
                        <div>
                            <p className="text-xs text-gray-600">Período</p>
                            <p className="text-sm font-medium text-gray-900">
                                {formatDateToString(data.SK_TEMPO_INICIO)} - {formatDateToString(data.SK_TEMPO_FIM)}
                            </p>
                        </div>
                    </div>
                </div> 
            </div>

            <div className="flex flex-1 gap-4">
                {profile == 'ADMINISTRADOR' && (
                    <button 
                        className="w-full btn-primary text-white font-medium py-2 px-4 rounded-lg flex items-center justify-center gap-2 text-sm" 
                        onClick={ () => navigate(`settings?search=${data.SK_PESQUISA}`)}
                    >
                        <i className="fas fa-arrow-right text-xs"></i>
                        Configurações da Pesquisa
                    </button>
                )}
                {['Publicado','Encerrado'].includes(data.DD_STATUS) && (
                    <button 
                        className="w-full btn-primary text-white font-medium py-2 px-4 rounded-lg flex items-center justify-center gap-2 text-sm"
                        onClick={ () => navigate(`details?search=${data.SK_PESQUISA}`)}
                    >
                        <i className="fas fa-arrow-right text-xs"></i>
                        Ver detalhes da pesquisa
                    </button>
                )}
            </div>
        </div>
    )
}

export default CardsResearch
